var D = /* @__PURE__ */ ((E) => (E.NEW = "NEW", E.REFUSED = "REFUSED", E.APPROVED = "APPROVED", E.OFFER_PENDING = "OFFER_PENDING", E.OFFERED = "OFFERED", E.COUNTERED = "COUNTERED", E.ACCEPTED = "ACCEPTED", E.DECLINED = "DECLINED", E.RENEWED = "RENEWED", E.CANCELLED = "CANCELLED", E.NEGOTIATION = "NEGOTIATION", E))(D || {}), N = /* @__PURE__ */ ((E) => (E.PENDING = "PENDING", E.REJECTED = "REJECTED", E.ACCEPTED = "ACCEPTED", E.CANCELLED = "CANCELLED", E))(N || {});
export {
  N as RenewalApplicationStatus,
  D as RenewalStatus
};
//# sourceMappingURL=renewal.js.map
